import { render, staticRenderFns } from "./nav-bar-mobile.vue?vue&type=template&id=23e84165&scoped=true&"
import script from "./nav-bar-mobile.vue?vue&type=script&lang=js&"
export * from "./nav-bar-mobile.vue?vue&type=script&lang=js&"
import style0 from "./nav-bar-mobile.vue?vue&type=style&index=0&id=23e84165&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e84165",
  null
  
)

export default component.exports